import Fit2Box from "vue-fit2box";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("fit2box", Fit2Box);
});
